<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/10/2021
  -->

<template>
	<el-dropdown
		@command="onOptionClicked"
		placement="bottom"
		trigger="click"
		v-bind="$attrs">
		<template #dropdown>
			<div v-if="dropDownTitle" class="p-2 bold font-size-2">
				{{dropDownTitle}}
			</div>

		<el-dropdown-menu >
			<el-dropdown-item v-for="(option, index) in options" :key="index"
							  :command="option" v-bind="option.options">
				<slot name="item">
					<div>
						<div>{{ option[labelKey] }}</div>
						<div v-if="option[descriptionKey]"><small class="text-muted">{{ option[descriptionKey] }}</small></div>
					</div>
				</slot>
			</el-dropdown-item>
		</el-dropdown-menu>
		</template>

		<template #default>
			<div>
				<slot name="trigger">
					<i class="fontello icon-arrow-combo hover-text"/>
				</slot>
			</div>
		</template>

	</el-dropdown>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwDropdown",
	extends: BaseComponent,

	props: {
		options: {Array, required: true},
		labelKey: {String, default: "label"},
		descriptionKey: {String, default: "description"},
		dropDownTitle: String,
	},
	inheritAttrs: false,

	methods: {
		onOptionClicked(option) {
			let eventName = "Button clicked"
			let title = `'${option[this.labelKey]}'`
			this.$analyticManager.trackEvent(eventName, {...this.analyticsPropsMethod(), title})
			this.$emit("click", option)
		},

		analyticsPropsInternal() {
			return {
				context: "dropdown"
			}
		},
	},
}
</script>

<style lang="scss">

</style>
